export default "__VITE_ASSET__a1bcec4a__"